import * as actions from '../../utils/Actions';

const initialState = {
    instituteList: [],
    showPageLoader: false,
}

export default function institute(state = initialState, action){

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type){

        case actions.pending(actions.GET_INSTITUTE_LIST):
            return {
                ...state,
                showPageLoader: true
            }

            
        case actions.fulfilled(actions.GET_INSTITUTE_LIST):
            return {
                ...state,
                instituteList: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.GET_INSTITUTE_LIST):
            return {
                ...state,
                showPageLoader: false
            }  

     
            
        default:
            return {...state}
    }

}